import { useState, useEffect } from "react";
import { doc, updateDoc, onSnapshot, arrayUnion } from "firebase/firestore";
import { db } from "../firebase";

export default function Chat({ gameId, player }) {
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const gameRef = doc(db, "games", gameId);
    
    const unsubscribe = onSnapshot(gameRef, (snapshot) => {
      if (snapshot.exists()) {
        setMessages(snapshot.data().messages || []);
      }
    });

    return () => unsubscribe();
  }, [gameId]);

  const sendMessage = async () => {
    if (!message.trim()) return;

    const gameRef = doc(db, "games", gameId);
    await updateDoc(gameRef, {
      messages: arrayUnion({
        player,
        message,
        timestamp: new Date().toISOString()
      })
    });

    setMessage("");
  };

  return (
    <div className="chat-container">
      <div className="chat-box">
        {messages.map((msg, index) => (
          <p key={index} className={msg.player === player ? "my-message" : "other-message"}>
            <strong>{msg.player === "red" ? "🔴 Red" : "🔵 Blue"}: </strong> {msg.message}
          </p>
        ))}
      </div>
      <div className="chat-input">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="메시지 입력..."
        />
        <button onClick={sendMessage} className="chat-btn">전송</button>
      </div>
    </div>
  );
}
